import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { generateAiTableRequest } from "../../../../../store/features/actions/competitorAiTableActions";
import Alert from "../../../../HtmlElements/Alert";
// import { set } from "react-datepicker/dist/date_utils";

let dimensionOptions = [
  { key: "Executive Snapshot", value: "Executive Snapshot" },
  { key: "MarketPosition", value: "Market Position & Customer Intelligence" },
  { key: "ProductInnovation", value: "Product & Innovation" },
  { key: "Financial Performance", value: "Financial Performance" },
  { key: "Marketing", value: "Marketing & Distribution" },
  { key: "OperationsAndSupplyChain", value: "Operations & Supply Chain" },
  { key: "OrgStructure", value: "Corporate & Organizational Structure" },
];

const CompetitorAiTableModal = ({
  user_id,
  user_role,
  client,
  competitor,
  showAiBuilder,
  setShowAiBuilder,
  aiBuilderDimensionOptions,
}) => {
  const dispatch = useDispatch();
  const { clientName, competitorName } = useParams();
  // console.log("aiBuilderDimensionOptions: ", aiBuilderDimensionOptions);
  const { loading } = useSelector((state) => state.competitorAiTableReducer);
  const [updatedDimensions, setUpdatedDimensions] = useState([]);
  const [show, setShow] = useState(showAiBuilder || false);
  const [dimension, setDimension] = useState("");
  const [userQuery, setUserQuery] = useState("");
  const [errors, setErrors] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);

  // const handleClose = () => {
  //   setShow(false);
  //   setShowAiBuilder(false);
  //   setDimension("");
  //   setUserQuery("");
  //   setErrors({});
  // };

  const handleClose = () => {
    setShow(false);
    setShowAiBuilder(false);
    setDimension("");
    setUserQuery("");
    setErrors({});
    setShowSuccess(false);
  };

  // const handleSubmit = () => {
  //   let err = {};

  //   if (!dimension) err.dimension = "Dimension is required";
  //   if (!userQuery.trim()) err.userQuery = "Query is required";

  //   setErrors(err);

  //   if (Object.keys(err).length > 0) return;

  //   dispatch(
  //     generateAiTableRequest({
  //       user_id,
  //       user_role,
  //       client,
  //       competitor,
  //       dimension,
  //       user_query: userQuery,
  //       callback: handleClose,
  //     })
  //   );
  // };
  const handleSubmit = () => {
    let err = {};

    if (!dimension) err.dimension = "Dimension is required";
    if (!userQuery.trim()) err.userQuery = "Query is required";

    setErrors(err);

    if (Object.keys(err).length > 0) return;

    dispatch(
      generateAiTableRequest({
        user_id,
        user_role,
        client,
        competitor,
        dimension,
        user_query: userQuery,
        callback: () => {
          setShowSuccess(true);

          setTimeout(() => {
            handleClose();
          }, 5000);
        },
      })
    );
  };

  useEffect(() => {
    console.log();
    const updatedDimensionOptions = dimensionOptions.filter(
      (dimension) =>
        aiBuilderDimensionOptions.includes(dimension.value) &&
        dimension.value !== "Financial Performance"
    );
    setUpdatedDimensions(updatedDimensionOptions);
  }, [competitorName, aiBuilderDimensionOptions]);

  return (
    <>
      {/* <Button variant="primary" onClick={() => setShow(true)}>
        Open Modal
      </Button> */}

      <Modal show={showAiBuilder} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Section</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {showSuccess && (
            <Alert
              type="success"
              message="Your request has been received. We’re generating your table—it’ll be ready in a few minutes."
            />
          )}

          <Form.Group className="mb-3">
            <Form.Label>
              <span className="fw-medium">Dimension </span>
              <span className="red" style={{ backgroundColor: "#fff" }}>
                *
              </span>
            </Form.Label>
            <Form.Select
              value={dimension}
              onChange={(e) => setDimension(e.target.value)}
              className="font13"
            >
              <option value="">Select Dimension</option>

              {updatedDimensions.map((item) => (
                <option key={item.key} value={item.key}>
                  {item.value}
                </option>
              ))}
            </Form.Select>

            {errors.dimension && (
              <small className="text-danger">{errors.dimension}</small>
            )}
          </Form.Group>

          <Form.Group>
            <Form.Label>
              <p className="fw-medium mb-1">
                What should this section cover?{" "}
                <span className="red" style={{ backgroundColor: "#fff" }}>
                  *
                </span>
              </p>{" "}
              <p className="font13 mb-2">
                Describe in plain english, CompIQ will generate the structure,
                columns, and data for this section automatically.
              </p>
            </Form.Label>

            <Form.Control
              as="textarea"
              rows={5}
              value={userQuery}
              onChange={(e) => setUserQuery(e.target.value)}
              placeholder="Enter your query"
            />

            {errors.userQuery && (
              <small className="text-danger">{errors.userQuery}</small>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            variant="success"
            onClick={handleSubmit}
            disabled={loading}
            className="submit_dim_btn"
          >
            {loading ? (
              <>
                <Spinner size="sm" animation="border" />
                Submitting...
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CompetitorAiTableModal;
